export default "__VITE_ASSET__DXmmAWbK__"